export const platformTypes = {
  FETCH_PLATFORM_DATA: 'platform/GETTING_DATA',
  UPDATE_PLATFORM_DATA: 'platform/UPDATE_DATA',
  GET_PLATFORM_DATA: 'platform/GET_PLATFORM_DATA',
  test: 'test/test',
};

const platformReducerDefaultState = {
  platformName: '',
  validation: false,
  formQuestion: '',
  platformContact: '',
  platformURL: '',
  platformCampus: [],
  typeUser: false,
  platformLogo: '',
  userTypeText: 'estudiante',
  companyTypeText: 'empresa',
  logoLink1: '',
  logoLink2: '',
  logoLink3: '',
  logoLink4: '',
  logoLink5: '',
  platformFullName: '',
  autoAcceptJobs: false,
  autoAcceptUsers: false,
  autoAcceptCompanies: false,
  publicVacancies: false,
  publicPosts: false,
  customImage: '',
  customSecondImage: '',
  customSecondImageLink: '',
  customThirdImage: '',
  mainTitle: 'Bolsa de empleo',
  mainSubText: 'Encuentra la mejor oportunidad laboral.',
  companyTitle: 'Publica tus oportunidades',
  companySubText: 'Encuentra al mejor talento',
  companyText: 'Aprovecha al máximo las herramientas y descubre los mejores perfiles para tu empresa. ',
  studentTitle: 'Posiciónate y descubre vacantes',
  studentSubText: 'Orienta tu carrera profesional',
  studentText: 'Los cambios son retos que abren puertas a nuevas oportunidades. ¡Aplica hoy al trabajo de tus sueños!',
  contentTitle: 'Tienes talento, solo necesitas impulsarlo',
  contentText: 'Desarrolla tu crecimiento profesional en un solo clic. ¡El futuro depende de lo que hagas hoy!',
  linkedinLink: '',
  interfaceSelected: 1,
  customLoginImage: '',
  customLoginAdminImage: '',
};

export default (state = {}, action) => {
  switch (action.type) {
    case platformTypes.FETCH_PLATFORM_DATA:
      return {
        ...state,
        ...action.payload,
      };
    case platformTypes.UPDATE_PLATFORM_DATA:
      return {
        ...state,
        ...action.data,
      };
    case platformTypes.GET_PLATFORM_DATA:
      return {
        ...state,
        skills: action.data,
      };
    default:
      return state;
  }
};
